import "./style.scss";
import { useEffect, useState } from "react";
import { admissionsOfficeHeaderTabsConst } from "@/src/constants/AdmissionOffice/admissionsOfficeConsts";
import { useDispatch } from "react-redux";
import { setTabsAdmissionsOffice } from "@/src/store/slices/AdmissionOffice/admissionOfficeDocSlice";
import { Link, useLocation, useNavigate } from "react-router-dom";
import SelectDefault from "../../SelectDefault/SelectDefault";
import BtnDefault from "../../BtnDefault/BtnDefault";
import Refresh from "@/src/svg/header/Refresh";
import DatabaseSvg from "@/src/svg/admissionOfficePage/DatabaseSvg";
import VerticalLine from "../../VerticalLine/VerticalLine";

const HeaderAdmissionsOffice = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [currentTab, setCurrentTab] = useState<string>("");
  const [currentSelect, setCurrentSelect] = useState<string>("");

  const parseAdmissionsOfficeUrl = (pathname: string) => {
    const parts = pathname.split("/").filter(Boolean);

    if (parts[0] !== "admissions-office") return null;

    const [, tab, slug] = parts;

    if (!tab || !slug) return null;

    const tabObj = admissionsOfficeHeaderTabsConst.find((t) => t.id === tab);
    if (!tabObj) return null;

    const option = tabObj.mass.find((m) => m.slug === slug);
    if (!option) return null;

    return {
      tabId: tabObj.id,
      selectName: option.name,
    };
  };

  useEffect(() => {
    const parsed = parseAdmissionsOfficeUrl(location.pathname);
    if (!parsed) return;

    setCurrentTab(parsed.tabId);
    setCurrentSelect(parsed.selectName);
    dispatch(setTabsAdmissionsOffice(parsed.tabId));
  }, [location.pathname]);

  const handleEventTab = (id: string) => {
    setCurrentTab(id);
    const tabObj = admissionsOfficeHeaderTabsConst.find((tab) => tab.id === id);
    if (tabObj && tabObj.mass.length > 0) {
      const firstSelect = tabObj.mass[0].name;
      setCurrentSelect(firstSelect);
      dispatch(setTabsAdmissionsOffice(id));
      navigateToPage(id, firstSelect);
    } else {
      dispatch(setTabsAdmissionsOffice(id));
      navigateToPage(id, currentSelect);
    }
  };

  const handleChangeEvent = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const value = event.target.value;
    setCurrentSelect(value);
    navigateToPage(currentTab, value);
  };

  const navigateToPage = (tab: string, select: string) => {
    const tabObj = admissionsOfficeHeaderTabsConst.find((t) => t.id === tab);
    const option = tabObj?.mass.find((o) => o.name === select);
    const slug = option?.slug || "admission";
    navigate(`/admissions-office/${tab}/${slug}`);
  };

  return (
    <div className="header-admissions-office">
      <div className="header-bottom-tabs">
        {admissionsOfficeHeaderTabsConst.map((tab) => (
          <div className={`header-bottom-tab ${tab.id === currentTab ? "active" : ""}`} key={tab.id} onClick={() => handleEventTab(tab.id)}>
            <BtnDefault>
              <p>{tab.title}</p>
            </BtnDefault>
          </div>
        ))}
      </div>
      <VerticalLine />
      {location.pathname !== "/documents-qr-code" && (
        <>
          <div className="header-bottom-select">
            <SelectDefault onChange={handleChangeEvent} value={currentSelect}>
              {admissionsOfficeHeaderTabsConst
                .find((item) => item.id === currentTab)
                ?.mass.map((option, index) => (
                  <option key={index} value={option.name}>
                    {option.name}
                  </option>
                ))}
            </SelectDefault>
          </div>
          <VerticalLine />
        </>
      )}
      <Link to={"/documents-qr-code"}>
        <BtnDefault reverse={true}>
          <p>Documents QR Code</p>
          <DatabaseSvg />
        </BtnDefault>
      </Link>
      <div className="header-bottom-buttons">
        <BtnDefault>
          <p>New document</p>
          <Refresh />
        </BtnDefault>
        <VerticalLine />
        <Link to={"/admissions-office-database"}>
          <BtnDefault reverse={true}>
            <p>Database</p>
            <DatabaseSvg />
          </BtnDefault>
        </Link>
      </div>
    </div>
  );
};

export default HeaderAdmissionsOffice;
